import { useMsal } from '@azure/msal-react';
import { ADMIN_GROUP_ID } from '@/authConfig';

/**
 * Returns true if the currently signed-in user is a member of the
 * SocialSpark-Admins Azure AD security group.
 *
 * Azure AD includes group memberships in the `groups` claim of the ID token
 * once "Token configuration → Add groups claim → Security groups" is enabled
 * on the app registration.
 */
export function useIsAdmin(): boolean {
  const { accounts } = useMsal();
  const account = accounts[0];
  if (!account) return false;

  const groups = (account.idTokenClaims as Record<string, unknown>)?.groups;
  if (!Array.isArray(groups)) return false;

  return groups.includes(ADMIN_GROUP_ID);
}
